import React from 'react';
import PropTypes from 'prop-types';
import './ModelAlert.css';

const ModelAlert = () => {
    return (
        <div className="alert__container">
            <span>
                <b>Please note</b>: If you decide to email all your supporters then your post
            </span>
            <span>will become inactive and no more comments will be accepted.</span>
        </div>
    );
};

ModelAlert.propTypes = {};

export default React.memo(ModelAlert);
